/* Русский — исходный язык. Все ключи заводятся здесь первыми: остальные
   словари переводят этот, а не друг друга.

   Ключ называет место и смысл, а не текст: op.doneBtn переживёт правку
   надписи, а «Завершить операцию» пришлось бы менять в трёх файлах. */

export default {
  common: {
    cancel: 'Отмена',
    ok: 'Готово',
    confirm: 'Подтвердить',
    close: 'Закрыть',
    refresh: 'Обновить',
    loading: 'загрузка…',
    exit: 'Выход',
    reset: 'Сброс',
    comment: 'Комментарий',
    commentOptional: 'Комментарий (необязательно)',
    commentRequired: 'Комментарий обязателен для этой причины',
    reason: 'Причина',
    machine: 'Станок',
    shift: 'Смена',
    theme: 'Тема',
    language: 'Язык',
    understood: 'Понятно',
    noConnection: 'Нет связи',
    connected: 'Связь есть',
    readOnly: 'просмотр',
  },

  login: {
    subtitle: 'Система оперативного управления производством',
    login: 'Логин',
    password: 'Пароль',
    submit: 'Войти',
    checking: 'Проверка…',
    toTerminal: 'Вход с цехового терминала',
    toPassword: 'Вход по логину и паролю',
  },

  terminal: {
    machine: 'Станок',
    setupTitle: 'Настройка терминала',
    setupHint: 'Устройство не привязано. Введите код терминала и токен, выданный при его создании.',
    code: 'Код терминала',
    token: 'Токен устройства',
    bind: 'Привязать',
    tabNumber: 'Табельный номер',
    pin: 'PIN',
    pickMachine: 'Выберите станок',
  },

  op: {
    needTabPin: 'Табельный номер и PIN',
    needTabPinWhy: 'Табельный номер и PIN обязательны: выпуск записывается на человека',
    scanOrType: 'Отсканируйте бирку или введите код',
    leaveTitle: 'Уход из смены',
    leaveText: 'Отметить уход: {name}?',
    leaveDetail: 'Часы присутствия закроются этим временем. Мастер сможет их поправить при закрытии смены',
    leaveOk: 'Отметить уход',
    qStart: 'Старт операции',
    qPause: 'Пауза',
    qDone: 'Завершение операции',
    qCallSetter: 'Вызов наладчика',
    qCallSupervisor: 'Вызов мастера',
    byTab: ' · таб. {tab}',
    jobReadyOne: 'Задание готово к запуску',
    jobReadyMany: 'Задания готовы к запуску',
    pressStart: 'Нажмите «Начать», когда встанете к станку',
    chooseOne: 'Выберите то, за которое беретесь',
    stockWarn: 'Расход материала списан не полностью',
    stockWarnHint: 'Выпуск принят. Скажите кладовщику или мастеру',
    setupTook: 'Переналадка заняла {time}',
    machineIs: 'Станок {code}.',
    machineIdleHint: 'Станок {code}. Мастер назначит задание, и оно появится здесь автоматически.',
    viewOnly: 'Рабочее место {code} · просмотр.',
    shiftTarget: 'в задании смены',
    shiftTargetOf: 'в задании смены: {qty} {unit}',
    start: 'Начать',
    tabNumber: 'Табельный номер',
    crewSelfNote: 'Каждый отмечается сам: PIN означает, что человек стоял у терминала',
    mark: 'Отметить',
    commentRequired: 'Комментарий обязателен для этой причины',
    confirm: 'Подтвердить',
    commentOptional: 'Комментарий (необязательно)',
    whatHappened: 'Что случилось (необязательно)',
    call: 'Вызвать',
    whoseOutput: 'Выпуск запишется на этого человека. Он должен быть отмечен в смене на этом станке',
    tagCode: 'Код с бирки',
    shareNote: '«Доля» — расчёт: бригадный выпуск поделён поровну между теми, кто был у станка в момент сдачи. Это оценка, а не измерение',
    workplace: 'Рабочее место',
    noJob: 'Задание не назначено',
    noJobHint: 'Мастер назначит задание, и оно появится здесь автоматически.',
    jobFromSupervisor: 'Задание сменить можно на экране участка, кнопкой «Задание» на карточке станка.',
    readOnlyNote: 'Сдача выпуска и закрытие операции — с терминала станка: '
      + 'в учёте должно остаться, кто именно это сделал.',
    remaining: 'осталось',
    of: 'из',
    byButtons: 'Кнопками',
    byKeyboard: 'Клавиатурой',
    all: 'Всё',
    good: 'Годное',
    scrap: 'Брак',
    defect: 'Дефект',
    waste: 'Возвратные отходы',
    wasteHint: 'Обрезь, концы, стружка — металл, который уйдёт в переплав',
    wasteQty: 'Сколько, {unit}',
    wastePlaceholder: 'например: концы бухты',
    pallet: 'Поддон собран',
    palletHint: 'Тара спишется по числу бухт на поддоне',
    palletCoils: 'Сколько бухт на поддоне',
    palletNoNorm: 'нормы нет',
    palletFact: 'факт',
    palletMissing: 'Не спишется без факта: {list}',
    palletQueued: 'Поддон: {n} бухт',
    pause: 'Пауза',
    resume: 'Продолжить работу',
    finish: 'Завершить операцию',
    pauseReason: 'Причина приостановки',
    doPause: 'Приостановить',
    callSupervisor: 'Вызвать мастера',
    callSetter: 'Вызвать наладчика',
    callWaiting: 'ожидайте, вызов принят системой',
    callSupervisorCalled: 'Вызван мастер',
    callSetterCalled: 'Вызван наладчик',
    callWhat: 'Что случилось (необязательно)',
    callHint: 'Коротко: что мешает работе',
    doCall: 'Вызвать',
    inPlan: 'в задании смены',
  },

  /* Сокращение «операция» перед её номером. */
  opSeq: 'оп.',

  batch: {
    inWork: 'В работе',
    notMarked: 'партия не отмечена',
    notMarkedWhy: '— брак будет безымянным',
    mark: 'Отметить партию',
    scrapBin: 'Лом в тару',
    binNotPicked: 'тара не выбрана',
    pickBin: 'Выбрать тару',
    tagCode: 'Код с бирки',
    tagHintBatch: 'Бирка того металла, что стоит у станка',
    tagHintBin: 'Бирка бункера, куда идёт брак',
    dlgBatch: 'Партия в работе',
    dlgBin: 'Тара под лом',
  },

  tools: {
    leftHours: 'осталось {h} ч работы',
    leftQty: 'осталось {n} шт',
    callNote: 'Оснастка: {list}',
    onMachine: 'На станке',
    remove: 'Снять',
    ok: 'в норме',
    soon: 'ресурс на исходе',
    spent: 'ресурс исчерпан',
    tellSetter: 'Сообщить наладчику',
  },

  setup: {
    running: 'Идёт переналадка',
    finish: 'Закончить переналадку',
    took: 'Переналадка заняла',
    start: 'Начать переналадку',
    startBtn: 'Начать',
    button: 'Переналадка',
    hint: 'Например: с Ø6 на Ø9',
  },

  crew: {
    onShift: 'В смене',
    markMe: 'Отметиться в смене',
    mark: 'Отметить',
    left: 'Ушёл',
    nobody: 'Никто не отмечен. Смена начинается с состава',
    pinWhy: 'Каждый отмечается сам: PIN означает, что человек стоял у терминала',
    shareHint: '«Доля» — расчёт: бригадный выпуск поделён поровну между теми, '
      + 'кто был у станка в момент сдачи. Это оценка, а не измерение',
    whoReports: 'Кто сдаёт',
    whoReportsHint: 'Выпуск запишется на этого человека. '
      + 'Он должен быть отмечен в смене на этом станке',
    doReport: 'Сдать',
  },

  andon: {
    reasonNotSet: 'Причина не указана',
    setterCalled: 'Вызван наладчик',
    supervisorCalled: 'Вызван мастер',
    plant: 'Предприятие',
    shiftNamed: 'Смена {code}',
    token: 'Токен устройства',
    bind: 'Привязать',
    byLogin: 'Вход по логину и паролю',
    exit: 'Выход',
    offline: 'Нет связи · данные {ago} назад',
    notMarked: 'Не отмечено',
    noReason: 'причина не указана',
    target: 'цель {p}',
    quality: 'годность {p}',
    title: 'АНДОН',
    setupTitle: 'Настройка табло',
    setupHint: 'Устройство не привязано. Введите код табло и токен устройства, выданные при его создании.',
    code: 'Код табло',
    unbind: 'Отвязать это табло',
    run: 'Работает',
    down: 'Стоп',
    maint: 'ТО',
    idle: 'Ожидание',
    oeeShift: 'OEE смены',
    goodShift: 'Годного за смену',
    attention: 'ТРЕБУЕТ ВНИМАНИЯ',
    calm: 'СПОКОЙНО',
    allQuiet: 'Остановленного оборудования и открытых вызовов нет',
  },

  /* Подписи перечислений. Накладываются поверх того, что отдаёт сервер:
     нет ключа — остаётся русская подпись из /meta. */
  /* Навигация. Оператор видит её каждую смену, поэтому переведена
     целиком, включая конторские разделы: пункт на чужом языке рядом
     с переведёнными читается как поломка, а не как «сюда не ходи». */
  nav: {
    groupShop: "Цех",
    groupQuality: "Качество",
    groupMetal: "Металл",
    groupPlans: "Планы и итоги",
    operator: "Рабочее место",
    operatorShort: "Место",
    melt: "Навеска",
    area: "Участок",
    maintenance: "Обслуживание",
    maintenanceShort: "ТО",
    quality: "Контроль",
    qualityShort: "СТК",
    lab: "Лаборатория",
    labShort: "Лаб.",
    certificates: "Сертификаты",
    certificatesShort: "Серт.",
    stock: "Материалы",
    stockShort: "Матер.",
    batches: "Партии",
    scrap: "Лом",
    orders: "Заказы",
    shift: "Смена",
    production: "Производство",
    productionShort: "Обзор",
    admin: "Настройки",
    company: "Предприятие",
  },

  /* Полоса состояния связи и счётчик смены. Они висят у оператора
     перед глазами всю смену — и оставались по-русски даже на узбекском
     экране. Утечка была не в редком диалоге, а в том, что читают чаще
     всего. */
  status: {
    retry: 'Повторить',
    discard: 'Отбросить',
    ok: 'Связь есть',
    pending: 'Отправка: {n} в очереди',
    offline: 'Нет связи',
    offlineQueued: 'Нет связи · {n} в очереди',
    degraded: 'События недоступны, данные обновляются по запросу',
    blocked: 'Очередь остановлена',
  },

  shift: {
    named: 'Смена {code}',
    namedWith: 'Смена {code} · {name}',
    left: 'осталось {time}',
    over: 'смена окончена',
    noBounds: 'границы смены не заданы',
    hours: '{h} ч',
    hoursMinutes: '{h} ч {m} мин',
    minutes: '{m} мин',
    progress: 'Смена пройдена на {p}%',
  },

  tool: {
    writeOff: 'ресурс исчерпан',
    regrind: 'пора на переточку',
    soon: 'ресурс на исходе',
  },

  melt: {
    title: 'Навеска',
    subtitle: 'Веса компонентов и доля от рецепта. Считается до закрытия печи',
    compCount: 'компонентов {n}',
    hangTag: 'Повесьте бирку на тару. Всё, что выйдет из этой партии, будет с ней связано',
    next: 'Следующая навеска',
    what: 'Что варим',
    choose: '— выберите —',
    noRecipes: 'Ни у одного материала не задан рецепт. Заведите его в настройках, в справочнике материалов',
    outTag: 'Бирка результата',
    other: 'Другая',
    outPh: 'Чистая бирка под результат',
    total: 'Всего в навеске',
    offRecipe: 'Вне рецепта',
    byRecipe: 'по рецепту',
    components: 'Компоненты',
    compPh: 'Бирка компонента',
    noTag: 'Без бирки',
    thComponent: 'Компонент',
    thTag: 'Бирка',
    thRecipe: 'По рецепту',
    thWeight: 'Вес',
    thShare: 'Доля',
    scanTag: 'отсканируйте бирку',
    scanOutFirst: 'Отсканируйте бирку результата, чтобы закрыть навеску',
    close: 'Закрыть навеску',
    pp: 'п.п.',
    tagTaken: '{code} уже привязана — возьмите чистую бирку',
    switchTitle: 'Сменить то, что варят',
    switchText: 'Веса уже введены. Смена цели пересоберёт строки по другому рецепту.',
    switchDetail: 'Введённые веса будут потеряны',
    switchOk: 'Сменить',
    offTitle: 'Навеска вне рецепта',
    offText: 'Вне допуска: {what}. Закрыть навеску всё равно?',
    offTextAny: 'Навеска вне рецепта. Закрыть всё равно?',
    offDetail: 'Расхождение останется в записи плавки и уйдёт в родословную партии',
  },
  enum: {
    orderStatus: {
      draft: 'Черновик', pending: 'На согласовании', approved: 'Согласован',
      planned: 'Запланирован', released: 'Выпущен', run: 'В работе',
      paused: 'Приостановлен', done: 'Завершён', closed: 'Закрыт', cancelled: 'Отменён',
    },
    orderOrigin: { sales: 'Под заказ клиента', internal: 'Внутренний', stock: 'На склад' },
    equipmentType: {
      enterprise: 'Предприятие', area: 'Цех', workcenter: 'Участок',
      machine: 'Оборудование', buffer: 'Буферная зона',
    },
    reasonCategory: {
      scrap: 'Окончательный брак', defect: 'Исправимый дефект', downtime: 'Внеплановый простой',
      maint: 'Плановый простой / ТО', pause: 'Приостановка операции', cancel: 'Отмена заказа',
      setup: 'Переналадка',
    },
    defectOrigin: {
      own: 'Свой передел', upstream: 'Предыдущий передел', material: 'Входной материал',
      metallurgy: 'Химия плавки', tooling: 'Оснастка и инструмент', unknown: 'Не установлено',
    },
    equipmentState: {
      run: 'Работает', idle: 'Ожидание', maint: 'Плановый простой / ТО',
      down: 'Стоп / авария', off: 'Выключено',
    },
    opStatus: {
      wait: 'Ожидает', active: 'Выполняется', paused: 'Приостановлена',
      done: 'Завершена', skipped: 'Пропущена',
    },
    outputKind: { good: 'Годное', scrap: 'Окончательный брак', defect: 'Исправимый дефект', rework: 'После доработки', waste: 'Возвратные отходы' },
    role: {
      operator: 'Оператор', qc: 'Контролёр СТК', setter: 'Наладчик',
      supervisor: 'Мастер', planner: 'Планировщик', manager: 'Руководство',
      admin: 'Администратор',
    },
  },
};
